import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { newRoute, editRoute } from "../../../shared/services/data.service";
import { despachosRoute } from "../../shared/data.service";
import { obrigacoesRoute } from "./data.service";

@Injectable()
export class ObrigacaoNavigationService {

  constructor(
    private _authService: AuthService
  ) { }

  goToList() {
    var router: string = despachosRoute + '/' + obrigacoesRoute;
    this._authService.navigateTo(router);
  }

  goToNew() {
    var router: string = despachosRoute + '/' + obrigacoesRoute + '/' + newRoute;
    this._authService.navigateTo(router);
  }

  goToEdit(objectId: number) {
    var router: string = despachosRoute + '/' + obrigacoesRoute + '/' + editRoute;
    this._authService.navigateTo(router, objectId);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/shared/obrigacao-navigation.service.ts
 **/